export var makeNotification = function makeNotification(_ref) {
  var theme = _ref.theme,
      type = _ref.type;
  return "color: #FFFF;\n          background-color: ".concat(type === 'error' ? theme.colors.danger.normal : theme.colors.secondary.normal, ";\n          border-radius: 8px;\n          position: fixed;\n          bottom: 30px;\n          left: 16px;\n          right: 16px;\n\n          @media (min-width: ").concat(theme.screen.smMin, "){\n            bottom: 44px;\n            left: auto;\n            right: 44px;\n          }\n\n          align-items: center;\n          justify-content: center;\n          display: flex;\n          padding: 0px 16px;\n          line-height: 48px;");
};
export var makeErrorIcon = function makeErrorIcon() {
  return "margin-right: 20px;";
};
export var makeSuccesIconNotification = function makeSuccesIconNotification() {
  return "margin-left: 20px;";
};